























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeReferensi } from "@/store/modules/referensi";

interface AutocompleteOptions {
  outlined: true;
  label: "";
}

@Component({
  components: {},
})
export default class BedKosongAutoComplete extends Vue {
  @Prop() setBed!: object;

  @Prop({
    default: () => {
      return {
        outlined: true,
        label: null,
      };
    },
  })
  opt: AutocompleteOptions;

  get listBed() {
    return storeReferensi.bedKosong;
  }

  // bed = {};

  // list = [];

  searchBed = null;

  loading = false;

  @Watch("setBed")
  valBed(val) {
    this.$emit("bed", val);
  }
}
